<div class="ds-flex ds-flex-col">
  <!-- Data -->
  <ds-form-field [label]="translations.receipt">
    <ds-date-picker [formControl]="selectedDateFormControl" />
  </ds-form-field>

  <p class="ds-text-default ds-font-regular ps-text">{{ translations.downloadPsReceipt }}</p>
</div>
